"use client";

import { useEffect } from "react";
import { useTodayProjectionStore } from "@/lib/stores/todayProjection";

export function useTodayProjection() {
  const data = useTodayProjectionStore((state) => state.data);
  const status = useTodayProjectionStore((state) => state.status);
  const error = useTodayProjectionStore((state) => state.error);
  const lastLoadedAt = useTodayProjectionStore((state) => state.lastLoadedAt);
  const lastInvalidatedAt = useTodayProjectionStore((state) => state.lastInvalidatedAt);
  const fetch = useTodayProjectionStore((state) => state.fetch);
  const refresh = useTodayProjectionStore((state) => state.refresh);
  const setProjection = useTodayProjectionStore((state) => state.setData);

  useEffect(() => {
    if ((status === "idle" || status === "error") && !data) {
      void fetch();
    }
  }, [data, fetch, status]);

  useEffect(() => {
    if (!lastInvalidatedAt || status === "loading") return;
    if (lastLoadedAt && lastInvalidatedAt <= lastLoadedAt) return;
    void refresh();
  }, [lastInvalidatedAt, lastLoadedAt, refresh, status]);

  return {
    projection: data,
    status,
    error,
    refresh,
    setProjection,
  };
}
